module.exports = __webpack_public_path__ + "static/img/zhutu叉车.d4e9610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhutu叉车.png
// module id = 2cxu
// module chunks = 0